// @flow
import hasPermission from '../globalFunctions/hasPermission';

export default {
  path: '/roles',
  component: () => import('modules/roles/Index.vue'),
  children: [
    {
      path: '',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Controle GU',
            name: 'IconListGU'
          }
        ]
      },
      name: 'IconListGU',
      component: () => import('modules/roles/IconListGU.vue'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.management.gu')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'gureports',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Controle GU',
            name: 'IconListGU'
          },
          {
            text: 'Relatórios',
            name: 'IconListRolesReports'
          }
        ]
      },
      name: 'IconListRolesReports',
      component: () => import('modules/roles/IconListRolesReports.vue'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.management.gu.report')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'accessreport',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Controle GU',
            name: 'IconListGU'
          },
          {
            text: 'Relatórios',
            name: 'IconListRolesReports'
          },
          {
            text: 'Relatório de Acessos',
            name: 'AccessReport'
          }
        ]
      },
      name: 'AccessReport',
      component: () => import('modules/roles/AccessReport.vue'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.management.gu.report.active.users')) {
          next();
        } else {
          next('/');
        }
      }
    },
  ]
};
